import { render, staticRenderFns } from "./ot-organisation-user-layout.vue?vue&type=template&id=ea2b886a&scoped=true&"
import script from "./ot-organisation-user-layout.vue?vue&type=script&lang=ts&"
export * from "./ot-organisation-user-layout.vue?vue&type=script&lang=ts&"
import style0 from "./ot-organisation-user-layout.vue?vue&type=style&index=0&id=ea2b886a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea2b886a",
  null
  
)

export default component.exports